import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import {modalClose} from "../genericFunctions";
import ReimbursementSpreadSheetForm, {
    ReimbursementSpreadSheetFormProps
} from "../../../pages/reimbursements/components/spreadsheet/ReimbursementSpreadSheetForm";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, ReimbursementSpreadSheetFormProps {
}

type Props = OwnProps;

const ReimbursementSpreadSheetModal = NiceModal.create<Props>(({onClose, header,...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <ReimbursementSpreadSheetForm {...rest}/>
        </SlideOver>
    )
})

export default ReimbursementSpreadSheetModal;
